import type { StepsIndicatorVariant } from '@/components/step-indicator/types';
import type { SwiperTheme } from './types';

export const indicatorVariantByTheme: Record<
  SwiperTheme,
  StepsIndicatorVariant
> = {
  light: 'dark',
  dark: 'light',
};

export const navButtonBase =
  'flex h-11 w-11 items-center justify-center rounded-full border transition duration-200 hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:opacity-30 disabled:cursor-not-allowed disabled:shadow-none sm:h-12 sm:w-12';

export const primaryShellBase =
  'relative w-full overflow-hidden py-6 sm:py-8 lg:px-10 lg:py-12 flex items-center justify-center';

export const primaryImageWrapper =
  'relative h-[220px] w-full overflow-hidden rounded-2xl sm:h-[320px] lg:h-[360px]';

export const themeStyles: Record<
  SwiperTheme,
  {
    background: string;
    container: string;
    heading: string;
    body: string;
    muted: string;
    accent: string;
    nav: string;
    focus: string;
    panel: string;
  }
> = {
  light: {
    background: '',
    container: 'text-neutral-900',
    heading: 'text-neutral-900',
    body: '[&_*]:text-neutral-700',
    muted: 'text-neutral-500',
    accent: 'text-brand-700',
    nav: 'bg-white text-neutral-900 border-neutral-200 hover:border-neutral-300 hover:shadow-md',
    focus: 'focus-visible:outline-brand-700',
    panel: 'shadow-[0_18px_45px_-32px_rgba(7,49,76,0.25)]',
  },
  dark: {
    background: 'bg-brand-800',
    container: 'text-white',
    heading: 'text-white',
    body: '[&_*]:text-white/80',
    muted: 'text-white/70',
    accent: 'text-white',
    nav: 'bg-white text-brand-800 border-white/20 hover:bg-white/90',
    focus: 'focus-visible:outline-white',
    panel: 'shadow-[0_18px_45px_-32px_rgba(0,0,0,0.6)]',
  },
};
